import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SeoHead, { SEO_KEYWORDS } from "../components/SeoHead";

const steps = [
  {
    step: "01",
    title: "Create an account",
    description:
      "Sign up for free with your email and password. Your account unlocks the inbox dashboard.",
  },
  {
    step: "02",
    title: "Choose your address",
    description:
      "Enter any username (e.g. example123) and your temporary inbox address becomes example123@ghostinbox.xyz.",
  },
  {
    step: "03",
    title: "Use it anywhere",
    description:
      "Paste your Ghost Inbox address on sign-up forms, trials, or verifications—just like a normal email.",
  },
  {
    step: "04",
    title: "Receive mail live",
    description:
      "Open the dashboard and load your inbox. Messages appear in real time with auto-refresh every 10 seconds.",
  },
  {
    step: "05",
    title: "Automatic cleanup",
    description:
      "All messages and inboxes expire after 20 minutes so nothing lingers on our servers.",
  },
];

function HowItWorks() {
  return (
    <Layout>
      <SeoHead
        title="How It Works – Ghost Inbox Temporary Inbox Guide"
        description="Learn how Ghost Inbox works: create a secure temporary inbox for testing and QA, receive verification emails in real time, and auto-delete messages after 20 minutes."
        path="/how-it-works"
        keywords={`how temp mail works, temporary email guide, ${SEO_KEYWORDS}`}
      />

      <div className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-3xl font-bold text-white">How it works</h1>
        <p className="mt-4 text-zinc-400 leading-relaxed">
          Ghost Inbox is a privacy-focused temporary inbox platform for ghostinbox.xyz. You get a
          real receiving address for testing, QA, and privacy protection — without exposing your
          personal inbox.
        </p>

        <div className="mt-12 space-y-8">
          {steps.map((item) => (
            <div
              key={item.step}
              className="flex gap-6 rounded-xl border border-zinc-800 bg-zinc-900/40 p-6"
            >
              <span className="font-mono text-2xl font-bold text-emerald-500/80">{item.step}</span>
              <div>
                <h2 className="text-lg font-semibold text-white">{item.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/signup"
            className="inline-block rounded-lg bg-emerald-500 px-8 py-3 text-sm font-semibold text-zinc-950 hover:bg-emerald-400"
          >
            Get started
          </Link>
        </div>
      </div>
    </Layout>
  );
}

export default HowItWorks;
